<template>
  <missing-fields-tooltip :missing-fields-list="listMissingFields">
    <v-btn
      :key="buttonkey"
      @click.once="click"
      class="management-button"
      :disabled="disabled"
      :class="{
        execute: type === 'execute',
        cancel: type === 'cancel',
        disabled: disabled,
      }"
      id="management-button"
      :loading="isLoading"
      :style="[
        align === 'left' ? { margin: '0 20px 10px 0 ' } : { margin: '0 0 10px 20px' },
      ]"
    >
      <slot />
      <span>{{ label }}</span>
    </v-btn>
  </missing-fields-tooltip>
</template>

<script>
import MissingFieldsTooltip from "@/components/_Atoms/MissingFieldsTooltip";

export default {
  name: "ManagementButton",

  components: { MissingFieldsTooltip },

  props: {
    /**
     * Label showed inside the button.
     */
    label: {
      type: String,
      required: true,
    },

    /**
     * The type of the button.
     * @values execute, cancel
     */
    type: {
      type: String,
      required: true,
      validator(value) {
        return ["execute", "cancel"].indexOf(value) !== -1;
      },
    },

    /**
     * Defines if the button is disabled or not
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * If the content of the page is loading or not.
     */
    isLoading: {
      type: Boolean,
      default: false,
    },

    /**
     * List of missing fields for the user being able add
     */
    listMissingFields: {
      type: Array,
      default: () => [],
    },

    /**
     * Determines button alignment
     */
    align: {
      type: String,
      default: "right",
    },
  },

  data() {
    return {
      buttonkey: 0
    }
  },

  methods: {
    /**
     * Sends an event to the parent warning about the click event.
     */
    click(e) {
      this.buttonkey++;
      this.$emit("buttonClick", e);
    }
  }
};
</script>

<style scoped>
#management-button.execute {
  background: var(--app-primary-base);
  color: white;
}

#management-button.execute.disabled {
  cursor: default;
  pointer-events: none;
  background-color: #f4f4f4;
  color: #bebec1;
}

#management-button.cancel {
  background: transparent;
  color: var(--primary-highlight);
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/ManagementButton.vue